import GlobalStyles, { V3Styles } from "../assets/styles/GlobalStyles";
import Header from "../components/section/header/Header";
import Layout from "../common/layout";
import Banner from "../components/section/banner";
import Counter from "../components/section/counter";
import CharacterSlider from "../components/section/characterSlider";
import HowToMint from "../components/section/howToMint";
import About from "../components/section/about/About";
import RoadMap from "../components/section/roadMap";
import Team from "../components/section/team";
import FAQ from "../components/section/faq";
import Footer from "../components/section/footer/Footer";

const HomeV3 = ({ variant }) => {
  return (
    <Layout>
      <GlobalStyles />
      <V3Styles />
      <Header variant={variant} />
      <Banner variant={variant} />
      <CharacterSlider />
      <Counter />
      <HowToMint />
      <About />
      <RoadMap color="#773ddd" />
      <Team />
      <FAQ />
      <Footer variant={variant} />
    </Layout>
  );
};

export default HomeV3;
